import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
// import HihglightOffIcon from '@material-ui/icons/HighlightOff';
import { AlertHelpDialog } from '@iris-platform/iris-react-ui';
import { HasPermission } from '@iris-platform/protektor';
import applicationPropType from '../applicationPropType';
// import { TeamContext } from '../../TeamProvider';
import {
  handleChange,
  stylesToPropType,
} from '../../../utils';
import Helpfile from '../helpfile.json';

import { PROTEKTOR_UPDATE } from '../../../utils/protektorConstants';

const styles = () => ({
  root: {
    width: '100%',
    '& [class^="MuiFormControl"]': {
      marginLeft: '12px',
    },
  },
  icon: {
    // margin: theme.spacing.unit,
    fontSize: 14,
    cursor: 'pointer',
  },
  iconbutton: {
    width: '18px',
    height: '18px',
  },
  saveButton: {
    borderRadius: '0.125em',
    marginTop: '.25em',
    width: '5em',
  },
});

class Settings extends Component {
  constructor(props) {
    super(props);

    const { application } = props;
    this.state = {
      application: {
        applicationID: application.applicationID,
        oauth2FriendlyName: application.oauth2FriendlyName,
      },
      error: false,
      pendingChanges: false,
      saving: false,
      title: 'Friendly Name for Login Screen',
      open: false,
      dialogTitle: '',
      dialogContent: '',
    };
  }

  // saveChanges = async () => {
  saveChanges = () => {
    const { ownerId, refreshApp, enqueueSnackbar } = this.props;
    const {
      application: {
        applicationID,
        oauth2FriendlyName,
      },
    } = this.state;
    // const currentTeam = TeamContext.getSelectedTeamId();
    const currentTeam = ownerId;
    const application = {
      applicationID,
      oauth2FriendlyName,
    };

    this.setState({ saving: true });

    const result = refreshApp(application, currentTeam);

    enqueueSnackbar('Login screen name updated', { variant: 'success' });

    this.setState({ pendingChanges: false });
    this.setState({ saving: false });
  }

  handleHelpOpen = (title, content) => {
    this.setState({
      open: true,
      dialogTitle: title,
      dialogContent: content,
    });
  };

  handleHelpClose = () => {
    this.setState({
      open: false,
      dialogTitle: '',
      dialogContent: '',
    });
  };

  render() {
    const { classes, role } = this.props;
    const {
      application: {
        oauth2FriendlyName,
      },
      error,
      pendingChanges,
      saving,
      title,
      open,
      dialogTitle,
      dialogContent,
    } = this.state;
    const help = Helpfile.oauth20;

    return (
      <Fragment>
        <form>
          <FormControl className={classes.root} error={error}>
            {/* {saving && (
              <LinearProgress />
            )}

            {error && (
              <FormHelperText className={classes.helper}>{error.message}</FormHelperText>
            )} */}

            <Typography
              component="div"
              variant="subheading"
              gutterBottom
            >
              {title}
              <IconButton className={classes.iconbutton} aria-label="Delete" onClick={() => this.handleHelpOpen(help.friendlyName.title, help.friendlyName.content)}>
                <HelpOutlineIcon className={classes.icon} />
              </IconButton>
            </Typography>
            <TextField
              label=""
              value={oauth2FriendlyName}
              placeholder="Friendly Name for login screen"
              onChange={(event) => {
                handleChange(this, ['application', 'oauth2FriendlyName'])(event);
                this.setState({ pendingChanges: true });
              }}
              type="text"
              disabled={!role.hasPermission({ action: PROTEKTOR_UPDATE, resource: 'Application_OAuth2_Tab_Login_Name' })}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
            />
            <br />
            <HasPermission
              to={PROTEKTOR_UPDATE}
              access="Application_OAuth2_Tab_Login_Name"
              forRole={role}
            >
              <Button
                variant="contained"
                classes={{ root: classes.saveButton }}
                disabled={!pendingChanges}
                onClick={this.saveChanges}
              >
                Save
              </Button>
            </HasPermission>
          </FormControl>
        </form>
        <AlertHelpDialog
          handleClose={this.handleHelpClose}
          open={open}
          dialogTitle={dialogTitle}
          dialogContent={dialogContent}
        />
      </Fragment>
    );
  }
}

Settings.propTypes = {
  application: applicationPropType.isRequired,
  classes: stylesToPropType(styles()).isRequired,
  refreshApp: PropTypes.func.isRequired,
  ownerId: PropTypes.string.isRequired,
  role: PropTypes.object.isRequired,
};

export default withSnackbar(withStyles(styles)(Settings));
